export default "__VITE_ASSET__B8AM1Ggb__"